import React from 'react'
import { PreviewImg } from '../../helper/imagepath'
import { appendImageURL, convertTimeToLocalTime } from '../../helper/function'
const RenderChatContent = ({ chat, index, endRef }) => {
  const { created_by_client, message, created_at, created_by_cleaners } = chat
  return (
    <div className="chat-message-group" key={`chat-key-${index}`}>
      <div className="received-wrapper">
        <img src={created_by_cleaners?.profile_image ? appendImageURL(created_by_cleaners?.profile_image) : PreviewImg} alt="sender-img" className="sender-dp" />
        <div className="received-block">
          {created_by_client?.first_name ? (
            <h6>{`${created_by_client?.first_name} ${created_by_client?.last_name}`}</h6>
          ) : (
            <h6>{`${created_by_cleaners?.first_name} ${created_by_cleaners?.last_name}`}</h6>
          )}

          <p>{message}</p>
          <div>
            <p className="send-time" style={{ color: '#666668' }}>
              {created_at && convertTimeToLocalTime(created_at)}
            </p>
          </div>
        </div>
      </div>
      <div ref={endRef} />
    </div>
  )
}
export default RenderChatContent
